import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List, Map, fromJS } from 'immutable';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import Icon from '../Icon/Icon';

import { money } from '../../utils/format';

import Link from '../Link/Link';

import { mapErrors, listMappedErrors } from './errors.jsx';
import { SingleBet } from 'src/components/BetSlip/SingleBet';
import { EmptyBet } from './EmptyBet';
import BetslipButtons from './BetslipButtons.jsx';
import BetReceipt from './BetReceipt.jsx';
import CombinationsList from './CombinationsList';

import Combination from './CombinationsList/Combination.jsx';
import { CombinationBetNew } from './CombinationBetNew';
import { AppStateComponent } from 'src/AppState/AppState';
import { getSelectionErrors } from './BetSlipHelper';
import { BonusEngineFreeBetErrorMessages } from './BonusEngineFreeBets/BonusEngineFreeBetErrorMessages';
import { fractionalToDecimal } from 'src/utils/helpers';
import { BetBuilderBet } from './BetBuilderBet/BetBuilderBet';

const EQUATION_IGNORED_FIELDS = [
    'potentialReturns',
    'potentialReturnsAt',
    'errors',
    'price',
    'freebetCredits',
    'freebetRemarks'
];

const SINGLES_COMBINATION = Map({
    type: 'SINGLES',
    name: 'All Singles Stakes'
});

function betEquals(bet, anotherBet) {
    let equals = true;

    bet.keySeq().forEach(key => {
        if (!EQUATION_IGNORED_FIELDS.includes(key)) {
            if (bet.get(key) !== anotherBet.get(key)) {
                equals = false;
            }
        }
    });

    return equals;
}

function betsEquals(bets, anotherBets) {
    return bets === anotherBets ||
        (
            bets.size === anotherBets.size &&
            bets.filter((bet, idx) => betEquals(bet, anotherBets.get(idx))).size === bets.size
        );
}

class BetSlip extends AppStateComponent {
    static propTypes = {
        id: PropTypes.number,
        accountId: PropTypes.number,
        legs: ImmutablePropTypes.map,
        bets: ImmutablePropTypes.list,
        combinations: ImmutablePropTypes.list,
        multiples: ImmutablePropTypes.map,
        errors: PropTypes.oneOfType([ ImmutablePropTypes.list, ImmutablePropTypes.map ]),
        bonusEngineFreeBets: ImmutablePropTypes.list,
        betPlacement: ImmutablePropTypes.map,
        offeredBetslip: ImmutablePropTypes.map,
        acceptReferredStatus: PropTypes.string,
        rejectReferredStatus: PropTypes.string,
        possibleBetStatus: PropTypes.string,
        totalFreebetAmount: PropTypes.number,
        competitions: ImmutablePropTypes.map,

        betslipUpdated: PropTypes.bool,

        playableBalance: PropTypes.number,
        depositLimits: ImmutablePropTypes.map,

        currency: ImmutablePropTypes.map,
        traderAssign: ImmutablePropTypes.map,

        permissions: ImmutablePropTypes.map,

        sportPriceLadders: ImmutablePropTypes.map,
        sports: ImmutablePropTypes.map,
        marketTemplates: ImmutablePropTypes.map,

        onCreateEmptyLeg: PropTypes.func.isRequired,
        onAddCombinedBet: PropTypes.func.isRequired,
        onBetChange: PropTypes.func.isRequired,
        onLegChange: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired,

        onGetPossibleBetsRequest: PropTypes.func.isRequired,
        onOfferReferredBetslip: PropTypes.func.isRequired,
        onPlaceBetRequest: PropTypes.func.isRequired,
        onAcceptReferredBetslip: PropTypes.func.isRequired,
        onRejectReferredBetslip: PropTypes.func.isRequired,
        onAddSplitBet: PropTypes.func.isRequired,
        onRemoveSplitBet: PropTypes.func.isRequired,
        onClearReferredBetslip: PropTypes.func.isRequired,
        onClearOfferReferredBetslip: PropTypes.func.isRequired,
        onAddMultiple: PropTypes.func,
        onClearMultiple: PropTypes.func,
        onRemoveMultiple: PropTypes.func,
        onAssignTrader: PropTypes.func,
        onGetSportPriceLadders: PropTypes.func,
        onGetMarketTemplatesList: PropTypes.func,
        bulkUpdateSelections: PropTypes.func.isRequired
    };

    static defaultProps = {
        legs: Map(),
        bets: List(),
        combinations: List(),
        multiples: Map(),
        errors: List(),
        currency: 'GBP',
        offeredBetslip: Map(),
        depositLimits: Map(),
        sportPriceLadders: Map(),
        sports: Map(),
        competitions: Map(),
        bonusEngineFreeBets: List()
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            focused: null,
            selected: props.bets.filter(bet => bet.get('legs').size === 1).map(bet => bet.getIn([ 'legs', 0 ])).toJS(),
            onCourse: false,
            changedBets: Map(),
            selectionsPlacementErrors: [],
            betsRefreshed: List(),
            combinationsRefreshed: List(),
            legsRefreshed: Map(),
            offerMade: false,
            offeredStake: '',
            offeredReturn: '',
            bonusEngineFreeBets: List(),
            selectedFreeBets: [],
            bbPriceStatus: null
        };
    }

    UNSAFE_componentWillMount() {

        const { onGetSportPriceLadders, sportPriceLadders } = this.props;
        if (!sportPriceLadders.size) {
            onGetSportPriceLadders();
        }

        setTimeout(() => {
            this.getPossibleBets(this.state.selected || [], this.props.bets, this.props.legs);
        }, 0);
    }

    UNSAFE_componentWillReceiveProps(props) {

        let shouldUpdatePossibleBets = false;

        this.setState({ selectionsPlacementErrors: this.getSuspendedSelection(props) });
     
        if (!betsEquals(props.bets, this.props.bets) || props.legs !== this.props.legs) {
            let selected = this.state.selected.filter(uid => props.legs.get(uid));
            
            const nextLegs = props.bets
                .filter(bet => !this.props.bets.find(b => b.get('uid') === bet.get('uid')))
                .filter(bet => bet.get('legs').size === 1)
                .map(bet => bet.getIn([ 'legs', 0 ]));
            selected = selected.concat(nextLegs.toJS());
            
            if (!isEqual(selected, this.state.selected)) {
                this.state.hoveredEventId = selected;
                this.setState({
                    selected
                });
            }
            
            shouldUpdatePossibleBets = true;
        }
        if (props.playableBalance !== this.props.playableBalance) {
            shouldUpdatePossibleBets = true;
        }

        const balanceRaised = shouldUpdatePossibleBets && this.props.playableBalance < props.playableBalance;
        if (balanceRaised && this.state.depositFlowStarted) {
            this.setState({
                depositFlowStarted: false
            });

            this.placeBet();
        }

        const betToRequest = props.bets.toJS();
        const combinations = betToRequest.filter(b => b.type !== 'SGL');


        this.setState({
            combinationsRefreshed: combinations
        });

        const selectedBets = this.state.selected;

        const legsToRequest = props.legs.toJS();

        for (const selectedBet of selectedBets) {
            const foundBet = legsToRequest[selectedBet];
            Object.keys(legsToRequest).forEach((legHash) => {
                const uid = legsToRequest[legHash].uid;
                if (foundBet && foundBet.uid && foundBet.uid === uid) {
                    legsToRequest[legHash].price = foundBet.price;
                    const foundBetInAllBets = betToRequest.findIndex(b => b.uid === uid);
                    if (foundBetInAllBets !== -1) {
                        betToRequest[foundBetInAllBets].price = foundBet.price;

                    }
                }

            });
        }

        this.setState({
            betsRefreshed: fromJS(betToRequest),
            legsRefreshed: fromJS(legsToRequest),
        });


        if (shouldUpdatePossibleBets && (!this.props.acceptReferredStatus || !this.props.betPlacement.get('state')) ) {
            this.setState({
                offerMade: false,
                offeredStake: '',
                offeredReturn: ''
            });
            setTimeout(() => {
                this.getPossibleBets(this.state.selected, this.state.betsRefreshed, this.state.legsRefreshed);
            }, 0);
        }


        if (
            props.acceptReferredStatus === 'FINISHED' ||
            props.betPlacement.get('state') === 'FINISHED' ||
            props.rejectReferredStatus === 'FINISHED'
        ) {
            this.setState({ changedBets: Map() });
        }
    }

    setBetBuilderPriceStatus = (status) => {
        this.setState({ bbPriceStatus: status });
    };

    selectFreeBet(freeBet) {
        this.setState({ selectedFreeBets: [...this.state.selectedFreeBets, freeBet] });
    }

    deselectFreeBet(freeBet) {
        const newSelectedFreeBets = this.state.selectedFreeBets.filter((bet) => {
            return bet.id !== freeBet.id;
        });

        this.setState({ selectedFreeBets: newSelectedFreeBets });
    }

    toggleFreeBet(freeBet) {
        const existingSelectedFreeBet = this.state.selectedFreeBets.find((selectedFreeBet) => {
            if (freeBet.type === 'SGL') {
                return selectedFreeBet.id === freeBet.id && selectedFreeBet.selectionId === freeBet.selectionId;
            }

            return selectedFreeBet.id === freeBet.id && selectedFreeBet.type === freeBet.type;

        });

        if (existingSelectedFreeBet === undefined) {
            this.selectFreeBet(freeBet);
        } else {
            this.deselectFreeBet(freeBet);
        }

        setTimeout(() => {
            this.getPossibleBets(this.state.selected, this.state.betsRefreshed, this.state.legsRefreshed);
        }, 0);
    }

    clearFreeBetSelection(betType, betUid) {
        const newSelectedFreeBets = this.state.selectedFreeBets.filter((bet) => {
            if (betUid === undefined || betUid === null || betType !== 'SGL') {
                return bet.type !== betType;
            }

            return bet.uid !== betUid;
        });

        this.setState({ selectedFreeBets: newSelectedFreeBets });

        setTimeout(() => {
            this.getPossibleBets(this.state.selected, this.state.betsRefreshed, this.state.legsRefreshed);
        }, 0);
    }


    focus(bet) {
        this.setState({
            focused: bet
        });
    }

    blur() {
        this.setState({
            focused: null
        });
    }

    getLeg(uid) {
        /* This function return object legs (Single Selection), if the combination bet was salved with a single selection where the pricetype was SP,
        will override the pricetype in sp, else return single selection*/

        const { bet, legs } = this;
        const leg = legs.get(uid).toJS();

        if (bet.priceType && bet.priceType[uid] === 'sp') {
            leg.priceType = 'sp';
        }

        return leg;
    }

    prepareBets(bets, legs, multiples) {
        legs = legs || this.props.legs;
        bets = bets || this.props.bets;

        bets = bets.toJS().map(bet => {
            bet.legs = bet.legs.map(this.getLeg, {
                bet: bet,
                legs: legs
            });

            return bet;
        });

        if (multiples && !multiples.isEmpty()) {
            multiples.map(m => bets.push(m.toJS()));
        }

        return bets;
    }

    getPossibleBets(selectedLegs, bets, legs) {
        const isFreeBet = this.props.totalFreebetAmount > 0;

        if (this.inPlacement()) {
            return;
        }
        const takeReferred = selectedLegs.length === 0;

        bets = this.prepareBets(bets, legs);
        bets.forEach(bet => {
            if (bet.isReferred && takeReferred) {
                bet.legs.forEach(leg => selectedLegs.push(leg));
            }
        });

        selectedLegs = selectedLegs.map(leg => {
            if (typeof leg === 'string') {
                leg = (legs || this.props.legs).get(leg) || leg;
            }

            return leg.toJS ? leg.toJS() : leg;
        }).filter(leg => typeof(leg) !== 'string');

        if ( bets.length && selectedLegs.length ) {
            this.props.onGetPossibleBetsRequest(
                bets,
                selectedLegs,
                this.state.onCourse ? 'on-course' : 'telebetting',
                isFreeBet,
                this.state.selectedFreeBets
            );
        }
    }

    inPlacement(props) {
        return (props || this.props).betPlacement.get('state') === 'IN_PROGRESS';
    }

    placeBet(value, isFreeBet = false) {
        const { onPlaceBetRequest, multiples } = this.props;

        if (this.inPlacement()) {
            return;
        }

        onPlaceBetRequest(
            this.prepareBets(void 0, void 0, multiples),
            this.state.onCourse ? 'on-course' : 'telebetting',
            value === 'override',
            isFreeBet,
            this.state.selectedFreeBets
        );
    }

    offerReferredBetslip(bets, legs, totalStake, potentialReturn) {

        const { onOfferReferredBetslip, multiples } = this.props;
        // FIXME: Consult whether it telebetting should stay
        // this.props.onClearMultiple();
        this.setState({
            offerMade: true,
            offeredStake: totalStake,
            offeredReturn: potentialReturn
        });
        onOfferReferredBetslip(
            this.prepareBets(bets, legs, multiples),
            this.state.onCourse ? 'on-course' : 'telebetting'
        );
    }

    acceptReferredBetslip(value) {
        const { onAcceptReferredBetslip } = this.props;

        onAcceptReferredBetslip(
            this.prepareBets(),
            this.state.onCourse ? 'on-course' : 'telebetting',
            value
        );
    }

    select(bet) {
        if (this.inPlacement()) {
            return;
        }

        const selected = this.state.selected.slice();

        if (selected.indexOf(bet.get('uid')) === -1) {
            selected.push(bet.get('uid'));


            this.setState({
                selected
            });


            this.getPossibleBets(selected);
        }
    }

    unselect(bet) {
        if (this.inPlacement()) {
            return;
        }

        const selected = this.state.selected.slice();
        const idx = selected.indexOf(bet.get('uid'));

        if (idx !== -1) {
            selected.splice(idx, 1);

            this.setState({
                selected
            });

            this.getPossibleBets(selected);

        }
    }
    toggleOnCourse() {
        this.setState({
            onCourse: !this.state.onCourse
        });
    }

    changeBet(bet, values) {
        if (this.inPlacement()) {
            return;
        }

        this.props.onBetChange(bet, values);
    }

    changeLeg(leg, values) {
        if (this.inPlacement()) {
            return;
        }

        this.props.onLegChange(leg, values);
    }

    addSplitBet(bet) {
        this.props.onAddSplitBet(bet.toJS());
    }

    removeSplitBet(bet) {
        this.props.onRemoveSplitBet(bet.toJS());
    }

    betWasChanged(bet, { price, areActive }) {
        let { changedBets } = this.state;

        changedBets = changedBets.set(bet.get('uid'), Map({
            price: Boolean(price),
            suspended: areActive && !(areActive.event && areActive.market && areActive.selection)
        }));

        return this.setState({
            changedBets
        });
    }

    setChangesStatus(bet, status) {
        let { changedBets } = this.state;

        if (status.includes('price-')) {
            changedBets = changedBets.setIn([ bet.uid, 'price' ], false);
        }

        return this.setState({ changedBets });
    }

    remove(index) {
        if (this.inPlacement()) {
            return;
        }

        let { changedBets } = this.state;
        changedBets = changedBets.remove(index);

        this.props.onRemove(index);
        this.setState({ changedBets });
        this.setState({ selectedFreeBets: this.state.selectedFreeBets.filter((bet) => bet.uid !== index) });
    }

    createEmptyLeg(e) {
        if (e) {
            e.preventDefault();
        }

        this.props.onCreateEmptyLeg();
    }

    makeCombinedBet(combination, stakePerLine) {
        if (this.inPlacement()) {
            return;
        }

        const { bets, legs } = this.props;
        const { selected } = this.state;

        if (!selected.length) {
            return;
        }

        this.props.onAddCombinedBet(
            combination,
            selected.map( x => {
                const uid = typeof x === 'string' ? x : x.uid;

                if (bets.find(y => y.get('uid') === uid)) {
                    return bets.find(y => y.get('uid') === uid).getIn([ 'legs', 0 ]);
                }
            }).filter(x => x),
            stakePerLine,
            this.getPriceType(bets, legs)
        );
    }

    getPriceType(bets, legs) {
    /* This function return new property 'priceType' for each Combination bet*/
        const priceType = {};

        bets.find(bet => bet.get('legs').find( uid => {
            priceType[uid] = legs.getIn([uid, 'priceType']);
        }));

        return priceType;
    }

    getMaxDeposit() {
        return this.props.depositLimits && this.props.depositLimits
            .toList()
            .filter(x => typeof x !== 'string' && x.get('active'))
            .map(x => x.getIn([ 'active', 'amount' ]) - x.getIn([ 'active', 'used' ]))
            .min();
    }

    startDepositFlow() {
        this.setState({
            depositFlowStarted: true
        });
    }

    checkLegsForSP(legsToCheck) {
        const { legs } = this.props;

        for (const leg of legsToCheck) {
            if (legs.getIn([ leg, 'priceType' ]) === 'sp') {
                return true;
            }
        }

        return false;
    }

    getSuspendedSelection(props) {
        /* This function return array of selection names who was suspended.
            var selectionErrors - array with Selection names suspended*/

        const { legs, bets, betPlacement } = props;
        const selectionErrors = [];
        const isReferred = bets.filter(bet => bet.get('isReferred')).size > 0;

        if (betPlacement.get('state') === 'ERROR' || isReferred) {
            for (const bet of bets) {
                const errors = bet.get('errors') ?? null;

                if (errors !== null) {
                    for (const error of errors) {
                        const errorCode = error.get('code') ?? null;
                        const valueF = error.getIn(['details', 'newValue','f']) ?? null;
                        const legPrice = legs.getIn([ bet.getIn([ 'legs', error.getIn([ 'leg', 'index' ]) ]), 'price' ]) ?? null;
                        const selectionId = error.getIn(['leg', 'selection', 'id']) ?? null;
                        const marketId = error.getIn(['leg', 'market', 'id']) ?? null;
                        const eventId = error.getIn(['leg', 'event', 'id']) ?? null;

                        const selectionErrorsInfo = getSelectionErrors(this.appState.sdkStaff.models, eventId, marketId, selectionId, errorCode, legPrice, valueF);
        
                        if (selectionErrorsInfo !== undefined && this.getExistObjInSelectionError(selectionErrors, selectionErrorsInfo) === false) {
                            selectionErrors.push(selectionErrorsInfo);
                        }
                    }
                }
            }
        }

        return selectionErrors.sort((a, b) => a.code === b.code ? (Number(a.name) - Number(b.name)) : (a.code < b.code ? -1 : 1));
    }

    getExistObjInSelectionError(array, object) {
        let hasObject = false;
        array.forEach( arr => {
            if (arr.name === object.name && arr.code === object.code) {
                hasObject = true;
            }
        }
        );
        return hasObject;
    }

    validateEmptyLeg(legs) {
        return legs
            .filter(l => l.get('type') === 'empty' &&
                (l.get('eventName') === '' || l.get('selectionName') === '' || l.get('sport') === ''))
            .size > 0;
    }

    isFPwithNoPrice(bets, legs) {
        return bets.filter(b => b.get('legs').filter(leg => {
            const innerLeg = legs.get(leg);
            return innerLeg && innerLeg.get('priceType') === 'fp' && (innerLeg.get('price') === '' || innerLeg.getIn(['price', 'd']) === 0 );
        }).size > 0 ).size > 0;
    }


    getStakeFromMultiples = (multiples) => {
        let stake = 0;
        for (const property in multiples) {
            const innerMultipleObject = multiples[property];
            const value = innerMultipleObject.stakePerLine * innerMultipleObject.numLines;
            const tempStake = innerMultipleObject.eachWay ? value * 2 : value;
            stake += tempStake;
        }
        return stake * 100;
    };

    getReturnFromMultiples = (multiples, combinations) => {
        let potentialReturns = 0;

        for (const property in multiples) {
            const innerMultipleObject = multiples[property];
            potentialReturns = potentialReturns + innerMultipleObject.potentialReturns;
        }

        return potentialReturns;
    };

    render() {
        const { id, combinations, currency, accountId,
            errors: possibleBetsErrors, betPlacement, playableBalance, offeredBetslip, acceptReferredStatus, onClearReferredBetslip,
            rejectReferredStatus, onRejectReferredBetslip, multiples, traderAssign, onAssignTrader, possibleBetStatus,
            sportPriceLadders, sports, onGetMarketTemplatesList, marketTemplates, totalFreebetAmount,
            onClearOfferReferredBetslip, bulkUpdateSelections, bonusEngineFreeBets, acceptReferredData } = this.props;
        const { focused, selected, onCourse, changedBets, selectionsPlacementErrors } = this.state;
        const maxDeposit = this.getMaxDeposit();
        const placementStatus = betPlacement.get('state');
        const bets = this.state.betsRefreshed;
        const legs = this.state.legsRefreshed;
        const multiplesJS = multiples.toJS();
        const combinationsJS = this.state.combinationsRefreshed;
        
        const errors = possibleBetsErrors?.size ? possibleBetsErrors : (offeredBetslip.get('errors') || acceptReferredData?.get('errors'));

        const singleBets = bets.filter(b => b.get('type') === 'SGL');



        const stakeMultiples = this.getStakeFromMultiples(multiplesJS);
        const returnFromMultiples = this.getReturnFromMultiples(multiplesJS, combinationsJS);
        const allBets = singleBets.toJS().concat(combinationsJS);
        const potentialReturnsValues = allBets.map((bet) => {
          if (bet.type === 'BB' && bet.price !== undefined) {
              return fractionalToDecimal(bet.price) * (bet.stakePerLine ?? 0) * 100;
          }

            return bet.potentialReturns;
        });
        const isAnyNA = potentialReturnsValues.some(value => value === null);

        const potentialReturns = isAnyNA === true ? 'n/a' : potentialReturnsValues
            .reduce((x, y) => x + (y || 0), 0);

        const anyBetHasSP = () => {
            for (const bet of bets) {
                if (this.checkLegsForSP(bet.get('legs'))) {
                    return true;
                }
            }

            return false;
        };

        const totalStake = 100 * allBets
            .reduce((x, y) => {
                let multiplier = y.numLines || 1;

                if (y.eachWay) {
                    multiplier *= 2;
                }
                return x + y.stakePerLine * multiplier;
            }, 0);

        const betslipClsName = classNames('betslip', 'form', {
            'betslip--progress': placementStatus === 'IN_PROGRESS',
            'betslip--success': placementStatus === 'FINISHED' ||
                                acceptReferredStatus === 'FINISHED' ||
                                rejectReferredStatus === 'FINISHED',
            'betslip--marked': focused && focused.size,
            'betslip--error': acceptReferredStatus === 'ERROR'
        });

        const betslipCustomerResponseClsName = classNames({
            'betslip--accepted-offered-bet': bets.size ? bets.getIn([0, 'referredStatus']) === 'accept' : false,
            'betslip--rejected-offered-bet': bets.size ? bets.getIn([0, 'referredStatus']) === 'reject' : false
        });

        const isReferred = bets.filter(bet => bet.get('isReferred')).size > 0;
        const isExpired = bets.filter(bet => bet.get('isExpired')).size > 0;
        const isSplitted = bets.filter(bet => bet.get('isSplitted')).size > 0;
        const offeredBetslipState = offeredBetslip.get('state');
        const assignedToMe = ( traderAssign && traderAssign.get('id') === accountId );

        const referredBet = bets.find(bet => bet.get('referredStatus'));

        let referredStatus;

        if (isReferred && referredBet) {
          referredStatus = referredBet.get('referredStatus');
        } else if (!offeredBetslipState && assignedToMe) {
          referredStatus = 'assigned';
        }
        else if (offeredBetslipState && offeredBetslipState !== 'ERROR' && assignedToMe) {
          referredStatus = 'offered';
        }

        if (placementStatus === 'FINISHED') {
            return (
                <BetReceipt bets={ betPlacement.get('bets') } currency={ currency.toJS().value }/>
            );
        }

        if (acceptReferredStatus === 'FINISHED') {
            return (
                <div className={ betslipClsName }>
                    <div className='betslip__success-message'>
                        Bet has been accepted!
                    </div>
                </div>
            );
        }

        if (rejectReferredStatus === 'FINISHED') {
            return (
                <div className={ betslipClsName }>
                    <div className='betslip__success-message'>
                        Bet has been rejected!
                    </div>
                </div>
            );
        }

        if (!bets.size) {
            return (
                <div className={ betslipClsName }>
                    <a onClick={ this.createEmptyLeg.bind(this)} className='btn betslip__add-empty-leg'>Add empty leg</a>
                    <div className='betslip__message'>
                        Waiting for selection
                    </div>
                </div>
            );
        }

        const betElements = bets.map((bet, idx) => {
            if (bet.get('type') === 'BB') {
                return (
                    <BetBuilderBet
                        userId={ this.props.id }
                        key={ idx }
                        currency={ currency.toJS() }
                        bet={ bet.toJS() }
                        legs={ legs.toJS() }
                        focusedBet={ focused !== null ?? focused.toJS() }
                        selected={ selected.indexOf(bet.get('uid')) !== -1 }
                        betWasChanged={ this.betWasChanged.bind(this)}
                        sportPriceLadders={ sportPriceLadders.toJS() }
                        onSelect={ this.select.bind(this, bet) }
                        onUnselect={ this.unselect.bind(this, bet) }
                        onChange={ this.changeBet.bind(this, bet) }
                        onLegChange={ this.changeLeg.bind(this)}
                        onRemove={ bets.filter(bet => bet.get('isReferred')).size === 1 ? onRejectReferredBetslip : this.remove.bind(this, bet.get('uid')) }
                        onAddSplitBet={ this.addSplitBet.bind(this, bet) }
                        onRemoveSplitBet={ this.removeSplitBet.bind(this, bet) }
                        onSetChangesStatus={ this.setChangesStatus.bind(this)}
                        assignedToMe={ assignedToMe }
                        inPlacement={() => this.props.betPlacement.get('state')}
                        isOffered={offeredBetslipState !== undefined}
                        bonusEngineFreeBets={bonusEngineFreeBets.toJS().filter((freeBet) => freeBet.uid === bet.get('uid'))}
                        selectedFreeBets={this.state.selectedFreeBets.filter((selectedFreeBet) => selectedFreeBet.uid === bet.get('uid'))}
                        toggleFreeBet={this.toggleFreeBet.bind(this)}
                        clearFreeBetSelection={this.clearFreeBetSelection.bind(this)}
                        onSetBetBuilderPriceStatus={this.setBetBuilderPriceStatus}
                    />
                );
            } else if (bet.get('type') !== 'SGL') {
                return (
                    <CombinationBetNew
                        key={idx}
                        combinations={combinations.toJS()}
                        currency={currency.toJS()}
                        bet={bet.toJS()}
                        legs={legs.toJS()}
                        focusedBet={focused !== undefined && focused !== null ? focused.toJS() : null}
                        onFocus={this.focus.bind(this, bet)}
                        onBlur={this.blur.bind(this, bet)}
                        onChange={this.changeBet.bind(this, bet)}
                        onRemove={bets.filter(bet => bet.get('isReferred')).size === 1 ? onRejectReferredBetslip : this.remove.bind(this, bet.get('uid'))}
                        assignedToMe={assignedToMe}
                        userId={ this.props.id }
                        bonusEngineFreeBets={bonusEngineFreeBets.toJS().filter((freeBet) => freeBet.type === bet.get('type'))}
                        selectedFreeBets={this.state.selectedFreeBets.filter((selectedFreeBet) => selectedFreeBet.type === bet.get('type'))}
                        toggleFreeBet={this.toggleFreeBet.bind(this)}
                        clearFreeBetSelection={this.clearFreeBetSelection.bind(this)}
                    />
                );
            } else if (legs.getIn([ bet.getIn([ 'legs', 0 ]), 'type' ]) === 'empty') {
                return (
                    <EmptyBet
                        key={ idx }
                        currency={ currency }
                        bet={ bet }
                        legs={ legs }
                        sports={ sports }
                        marketTemplates={ marketTemplates }
                        focusedBet={ focused }
                        selected={ selected.indexOf(bet.get('uid')) !== -1 }
                        onSelect={ this.select.bind(this, bet) }
                        onUnselect={ this.unselect.bind(this, bet) }
                        onChange={ this.changeBet.bind(this, bet) }
                        onLegChange={ this.changeLeg.bind(this)}
                        onRemove={ bets.filter(bet => bet.get('isReferred')).size === 1 ? onRejectReferredBetslip : this.remove.bind(this, bet.get('uid')) }
                        assignedToMe={ assignedToMe }
                        onGetMarketTemplatesList={ onGetMarketTemplatesList }
                    />
                );
            } else {
                return (
                    <SingleBet
                        userId={ this.props.id }
                        key={ idx }
                        currency={ currency.toJS() }
                        bet={ bet.toJS() }
                        legs={ legs.toJS() }
                        focusedBet={ focused !== null ?? focused.toJS() }
                        selected={ selected.indexOf(bet.get('uid')) !== -1 }
                        betWasChanged={ this.betWasChanged.bind(this)}
                        sportPriceLadders={ sportPriceLadders.toJS() }
                        onSelect={ this.select.bind(this, bet) }
                        onUnselect={ this.unselect.bind(this, bet) }
                        onChange={ this.changeBet.bind(this, bet) }
                        onLegChange={ this.changeLeg.bind(this)}
                        onRemove={ bets.filter(bet => bet.get('isReferred')).size === 1 ? onRejectReferredBetslip : this.remove.bind(this, bet.get('uid')) }
                        onAddSplitBet={ this.addSplitBet.bind(this, bet) }
                        onRemoveSplitBet={ this.removeSplitBet.bind(this, bet) }
                        onSetChangesStatus={ this.setChangesStatus.bind(this)}
                        assignedToMe={ assignedToMe }
                        inPlacement={() => this.props.betPlacement.get('state')}
                        isOffered={offeredBetslipState !== undefined}
                        bonusEngineFreeBets={bonusEngineFreeBets.toJS().filter((freeBet) => freeBet.uid === bet.get('uid'))}
                        selectedFreeBets={this.state.selectedFreeBets.filter((selectedFreeBet) => selectedFreeBet.uid === bet.get('uid'))}
                        toggleFreeBet={this.toggleFreeBet.bind(this)}
                        clearFreeBetSelection={this.clearFreeBetSelection.bind(this)}
                    />
                );
            }
        }).sortBy((x, idx) => bets.getIn([ idx, 'legs' ]).size !== 1).toArray();

        let errorsEl;
        let depositNeeded;
        if (errors && errors instanceof Map){
            errorsEl = (
                <ul className='betslip-errors'>
                    {
                        listMappedErrors(mapErrors(errors), {
                            'Wallet:minimum': details => {
                                const amount = details.get('details');
                                depositNeeded = amount.get('requiredAmount') - amount.get('currentAmount');

                                return (
                                    <li className='betslip-errors-deposit' key='Wallet:minimum'>
                                            To place bet with Real Money you need { money(depositNeeded, currency.toJS()) } more.
                                    </li>
                                );
                            }
                        })
                    }
                </ul>
            );
        }

        if (errors && !(errors instanceof Map) && errors.filter((error) => !error.get('resource').includes('bonus-engine')).size) {
            errorsEl = (
                <ul className='betslip-errors'>
                    {
                        listMappedErrors(mapErrors(errors.filter((error) => !error.get('resource').includes('bonus-engine'))), {
                            'Wallet:minimum': details => {
                                const amount = details.get('details');
                                depositNeeded = amount.get('requiredAmount') - amount.get('currentAmount');

                                return (
                                    <li className='betslip-errors-deposit' key='Wallet:minimum'>
                                            To place bet with Real Money you need { money(depositNeeded, currency.toJS()) } more.
                                    </li>
                                );
                            }
                        })
                    }
                </ul>
            );
        }

        let errorSomeSelectionSuspended;
        if (selectionsPlacementErrors) {
            errorSomeSelectionSuspended =
               selectionsPlacementErrors.map( selectionName => {
                   return (
                       ['decreased','increased'].includes(selectionName.code) ?
                           <ul className='betslip-errors-price-change'>
                               <li> { `${selectionName.name } price is different` } </li>
                               <li> { `Selection price: ${ selectionName.priceSelection } Bet price: ${ selectionName.priceBet ? (Map.isMap(selectionName.priceBet) && selectionName.priceBet.get('d')) || selectionName.priceBet : ''}` } </li>
                           </ul> :

                           <ul className='betslip-errors'>
                               <li className='betslip-errors-deposit'>
                                   {`${selectionName.name } is ${ selectionName.code}`}
                               </li>
                           </ul>
                   );
               });
        }
        let depositButtonEl;
        if (depositNeeded) {
            depositButtonEl = (
                <Link
                    key='deposit-button'
                    onClick={ this.startDepositFlow.bind(this)}
                    route={ `customers:${ id}` }
                    parameters={{
                        tab: 'customer',
                        'tab.tab': 'banking',
                        'tab.tab.tab': 'deposit',
                        amount: depositNeeded / 100
                    }}
                    className='btn'
                >
                    Deposit now
                </Link>
            );
        }

        let multipleLegLabel;
        if (!combinations.isEmpty()) {
            multipleLegLabel = <span className='betslip-multiples-label'>Include in multiplies</span>;
        }

        let depositLimitEl;
        if (depositNeeded && depositNeeded > maxDeposit) {
            depositLimitEl = (
                <div className='betslip__error--inline'>
                    Bet exceeds deposit limit<br />
                    Max possible bet: { money(maxDeposit + playableBalance, currency) }
                </div>
            );
        }
        let assigneeInfo;

        if (traderAssign && isReferred) {
            assigneeInfo = (
                <div className='betslip__message betslip__message--assignee'>
                    Bet referral is assigned to <strong>{ assignedToMe ? 'you' : traderAssign.get('name') }</strong>
                </div>
            );
        }

        // Currently this one is done because the freebet key comes through push notifications and the bet
        // was already eligible for placement
        const isReferralFreeBet = Boolean(bets.concat( multiples.toList() ).find( bet => bet.get( 'freebet' ) ));

        // Can be handy in the future


        const possibleReturnsWithoutStake = isReferralFreeBet && (potentialReturns + returnFromMultiples) > totalStake ?
            (potentialReturns + returnFromMultiples) - totalStake : potentialReturns + returnFromMultiples ;

        // const possibleReturnsWithoutStake = isReferralFreeBet && (potentialReturns ) > totalStake ?
        //     (potentialReturns) - totalStake : potentialReturns ;

        const shouldShowFreeBetButton = this.appState.configState.config.showBonusEngine;

        const BetSummary = () => {
          const betSummaryData = this.state.offerMade === false ? {
            currency: currency.toJS().value,
            potentialReturns: possibleReturnsWithoutStake,
            totalStake: totalStake + stakeMultiples
          } : {
            currency,
            potentialReturns: this.state.offeredStake,
            totalStake: this.state.offeredStake
          };

          return (
            <>
              Total stake: { money(betSummaryData.totalStake, betSummaryData.currency) }
              {
                  isReferralFreeBet ? (
                      <span className='betslip__freebet'><Icon name='gift'/> Free Bet</span>
                  ) : void 0
              }
              <br />
              Potential returns: { anyBetHasSP() ? 'n/a' : money(betSummaryData.potentialReturns, betSummaryData.currency) }
            </> 
          )
        }

        return (
            <div className={ betslipClsName }>
                {!isReferred && <a onClick={ this.createEmptyLeg.bind(this)} className='btn betslip__add-empty-leg'>Add empty leg</a> }

                { assigneeInfo }

                <ul className={betslipCustomerResponseClsName}>
                    { betElements }
                </ul>

                { multipleLegLabel }

                {
                    !combinations.isEmpty() && bets.count() > 1 ?
                        <ul className='betslip-combination betslip-combination--custom'>
                            <Combination
                                key={ SINGLES_COMBINATION.type }
                                combination={ SINGLES_COMBINATION }
                                currency={ currency }
                                potentialReturns={ 0 }
                                allowSaveLeg={ false }
                                allowRemoveLeg={ false }
                                onAddMultiple={ data => bulkUpdateSelections( data.get( 'stakePerLine' ) ) }
                                bonusEngineFreeBets={bonusEngineFreeBets.toJS().filter((freeBet) => freeBet.type === SINGLES_COMBINATION.type)}
                                selectedFreeBets={this.state.selectedFreeBets.filter((selectedFreeBet) => selectedFreeBet.type === SINGLES_COMBINATION.type)}
                                toggleFreeBet={this.toggleFreeBet.bind(this)}
                                clearFreeBetSelection={this.clearFreeBetSelection.bind(this)}
                                isBonusEngine={this.appState.configState.config.showBonusEngine}
                                userId={ this.props.id }
                            />
                        </ul> : void 0
                }

                <CombinationsList
                    combinations={ combinations }
                    currency={ currency }
                    selectedSP={ this.checkLegsForSP(selected) }
                    legsIds={ selected }
                    multiples={ multiples }
                    channel={ this.state.onCourse ? 'on-course' : 'telebetting' }
                    onMakeCombinationBet={ this.makeCombinedBet.bind(this)}
                    allowFreeBet={ totalFreebetAmount > 0}
                    onAddMultiple={ this.props.onAddMultiple }
                    onRemoveMultiple={ this.props.onRemoveMultiple }
                    onClearMultiple={ this.props.onClearMultiple }
                    bonusEngineFreeBets={bonusEngineFreeBets.toJS()}
                    selectedFreeBets={this.state.selectedFreeBets}
                    toggleFreeBet={this.toggleFreeBet.bind(this)}
                    clearFreeBetSelection={this.clearFreeBetSelection.bind(this)}
                    isBonusEngine={this.appState.configState.config.showBonusEngine}
                    userId={ this.props.id }
                />

                <div className='betslip-summary'>
                    <div className='checkbox'>
                        <input
                            type='checkbox'
                            checked={ onCourse }
                            onChange={ this.toggleOnCourse.bind(this)}
                        /> On course
                    </div>
                    <BetSummary />


                    { isReferralFreeBet ? <span className='betslip__exclude-stake'> (excludes stake)</span> : void 0 }
                    { depositLimitEl }

                    { errorsEl }
                    {errors && errors.size && !(errors instanceof Map) && <BonusEngineFreeBetErrorMessages errors={errors.toJS()} />}
                    { errorSomeSelectionSuspended }

                    <div className='buttons' key='betslip-buttons-container'>
                        { depositButtonEl }
                        <BetslipButtons
                            key='betslip-buttons-list'
                            isStakeEmpty={
                                bets.concat(multiples.toList()).filter(b => b.get('stakePerLine') > 0).size === 0
                            }
                            totalFreebetAmount={ totalFreebetAmount }
                            isReferralFreeBet={ isReferralFreeBet }
                            isFPwithNoPrice={ this.isFPwithNoPrice(bets.concat(multiples.toList()), legs) }
                            emptyLegInvalid={ this.validateEmptyLeg(legs) }
                            offeredBetslip={ offeredBetslip }
                            referredStatus={ referredStatus }
                            isSplitted={ isSplitted }
                            isExpired={ isExpired }
                            isReferred={ isReferred }
                            changedBets={ changedBets }
                            onPlaceBet={ this.placeBet.bind(this)}
                            onAcceptReferredBetslip={ this.acceptReferredBetslip.bind(this)}
                            onOfferReferredBetslip={ this.offerReferredBetslip.bind(this)}
                            onClearReferredBetslip={ onClearReferredBetslip }
                            onClearOfferReferredBetslip={ onClearOfferReferredBetslip }
                            onRejectReferredBetslip={ onRejectReferredBetslip }
                            onAssignTrader={ onAssignTrader }
                            traderAssign={ traderAssign }
                            accountId={ accountId }
                            permissions={ this.props.permissions }
                            placementStatus={ placementStatus }
                            bets={ bets }
                            legs={ legs }
                            selectionsPlacementErrors={ selectionsPlacementErrors }
                            getPossibleBets={ this.getPossibleBets.bind(this)}
                            selected={ selected }
                            multiples={ multiples }
                            possibleBetStatus={ possibleBetStatus }
                            errors={ errors || Map() }
                            acceptReferredStatus={acceptReferredStatus}
                            totalStake={totalStake + stakeMultiples}
                            potentialReturns={possibleReturnsWithoutStake}
                            shouldShowFreeBetButton={shouldShowFreeBetButton}
                            bbPriceStatus={this.state.bbPriceStatus}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default BetSlip;
